module.exports = __webpack_public_path__ + "img/jepang.6cf7e7e1.svg";